module.exports = __webpack_public_path__ + "toolkit-static/img/2-server-err.3fdb1ccb.png";